
// define web component for materials-option-select-list

class MaterialsOptionSelectList extends HTMLElement {
  // setup by
  constructor() {
    super();
    this.modal = this.closest('.modal');
    this.showMoreButton = this.querySelector('[data-showmore-button]');
    this.options = this.querySelectorAll('[data-option]');
    this.showMoreButton.addEventListener('click', () => {
      this.toggleShowMore();
    });
    this.showThreshold = 5;
    this.showMoreActive = false;
    this.is_mobile = window.matchMedia('(max-width: 768px)').matches;

    this.handleOptionSelect = this.handleOptionSelect.bind(this);
    this.options.forEach(option => {
      option.addEventListener('click', this.handleOptionSelect);
    });

    this.handleSizes = this.handleSizes.bind(this);
    this.updateShowMoreState = this.updateShowMoreState.bind(this);
  }

  // update show more state function that checks how many options are visible on one line (minus 1) and setting a useShowMore state
  // if the number of options is greater than the number of visible options
  connectedCallback() {
    window.addEventListener('resize', () => {
      this.handleSizes();
    });
    this.handleSizes();
  }

  handleOptionSelect(event) {
    const selectedOption = event.target.closest('[data-option]'),
          listItem = selectedOption.closest('li')
    if (selectedOption) {
      const option = selectedOption.dataset;

      this.updateOption(option);

      this.options.forEach(option => {
        option.closest('li').classList.remove('selected');
      });
      listItem.classList.add('selected');
    }
  }

  updateOption(option) {
    this.modal.classList.add('loading');
    this.modal.classList.add('loading-image');

    const title = option.title,
          variantTitle = option.variantTitle,
          description = option.description,
          imageUrl = option.image_url,
          // productId = option.productId,
          // productTitle = option.productTitle,
          // productUrl = option.productUrl,
          details = JSON.parse(option.productDetails),
          modalImage = this.modal.querySelector('[data-modal-image] img'),
          currentImage = modalImage.getAttribute('img_url').split('&width=')[0]
    let   imageLoadTime = 0;

    let loadDelay = setInterval(() => {
      imageLoadTime += 100;
      if (imageLoadTime > 600) clearInterval(loadDelay);
    }, 100);

    function removeImageLoadingClass() {
      this.modal.classList.remove('loading-image');
      clearInterval(loadDelay);
    }
    modalImage.onload = () => {
      setTimeout(removeImageLoadingClass.bind(this), 600 - imageLoadTime);
    }

    function updateModal() {
      const availableSizes = [550, 720, 990, 1100, 1500, 2200, 3000];
      const srcset = generateSrcset(imageUrl, availableSizes);

      modalImage.src = modalImage.src.replace(currentImage, imageUrl);
      modalImage.srcset = srcset;

      if (!title) {
        this.modal.querySelector('[data-modal-title').closest('[data-modal-title-wrap]')?.classList.add('no-title');
      } else {
        this.modal.querySelector('[data-modal-title').closest('[data-modal-title-wrap]')?.classList.remove('no-title');
      }
      this.modal.querySelectorAll('[data-modal-title').forEach(titleSlot => titleSlot.innerHTML = title);
      this.modal.querySelector('[data-modal-description').innerHTML = description;
      this.modal.querySelector('[data-modal-variant-title').innerHTML = variantTitle;

      this.modal.querySelector('[data-details').innerHTML = '<hr class="materials-gallery__modal-detail-divider" />';
      for (let i=1; i<7; i++) {
        if (details[`drawer_header_${i}`] && details[`drawer_content_${i}`]) {
          const detailHTML = `<h3 class="materials-gallery__modal-detail-title">${details[`drawer_header_${i}`]}</h3>
                              <p class="materials-gallery__modal-detail-text">
                                ${details[`drawer_content_${i}`]}
                              </p>
                              <hr class="materials-gallery__modal-detail-divider" />`
          this.modal.querySelector('[data-details').innerHTML += detailHTML;
        }
      }

      this.modal.classList.remove('loading');
    }
    setTimeout(updateModal.bind(this), 500);

  }

  toggleShowMore() {
    this.showMoreActive = !this.showMoreActive;
    this.updateShowMoreState();
    this.showMoreButton.setAttribute('aria-expanded', this.showMoreButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    this.showMoreButton.setAttribute('aria-label', this.showMoreButton.getAttribute('aria-expanded') === 'true' ? 'Show less' : 'Show more');
  }

  handleSizes() {
    this.is_mobile = window.matchMedia('(max-width: 768px)').matches;
    this.showThreshold = this.is_mobile ? 6 : 5;
    this.querySelector('[data-showmore-amount]').textContent = this.options.length - this.showThreshold;
    this.updateShowMoreState();
  }

  updateShowMoreState() {
    this.options.forEach((option, index) => {
      if (index < this.showThreshold) {
        option.parentElement.style.display = 'block';
      } else {
        if (this.showMoreActive) {
          option.parentElement.style.display = 'block';
        } else {
          option.parentElement.style.display = 'none';
        }
      }
    });
    
    if (this.options.length <= this.showThreshold) {
      this.showMoreButton.style.display = 'none';
      this.showMoreActive = false;
    } else {
      this.showMoreButton.style.display = 'block';
    }

    this.showMoreActive ? this.classList.add('show-more-active') : this.classList.remove('show-more-active');
    // const visibleOptions = Array.from(this.options).filter(option => option.offsetParent !== null);
    // const showMore = this.options.length > visibleOptions.length + 1;
    // this.showMoreButton.style.display = showMore ? 'block' : 'none';
    // // set the data-showmore-amount based on how many options are hidden
    // const hiddenOptions = this.options.length - visibleOptions.length;
    // this.showMoreButton.querySelector('[data-showmore-amount]').textContent = hiddenOptions;
    // this.showMoreButton.setAttribute('aria-expanded', showMore);
    // this.showMoreButton.setAttribute('aria-label', showMore ? 'Show less' : 'Show more');
    // this.showMoreButton.setAttribute('aria-hidden', !showMore);
  }
}
customElements.define('materials-option-select-list', MaterialsOptionSelectList);

class MaterialsGalleryModalTrigger extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById('materials-gallery__modal');
    this.closeButton = this.modal?.querySelector('.modal__toggle');

    if (!this.modal) {
      return;
    }

    this.freezeScroll = this.dataset.freezeScroll == 'true';
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.loadModalContent = this.loadModalContent.bind(this);

    this.scrollTarget = this.closest('body') || window;

    // focusout firing x times at the moment
    this.modal.addEventListener('keyup', this.onKeyUp.bind(this));
    this.modal.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  connectedCallback() {
    this.addEventListener('click', this.showModal);
    this.closeButton?.addEventListener('click', this.hideModal);
  }

  disconnectedCallback() {
    // this.scrollTarget.removeEventListener('scroll', this._boundHideModalOnScroll);
    this.removeEventListener('click', this.showModal);
    this.closeButton?.removeEventListener('click', this.hideModal);
  }

  showModal(e) { 
    if (!this.modal.dataset.modalId || this.modal.dataset.modalId !== this.dataset.modalBlockId) {
      this.loadModalContent();
    } else {
      this.modal.classList.remove('loading');
      this.modal.classList.remove('loading-image');
    }

    this.openedBy = opener;
    document.querySelectorAll('.modal--visible').forEach((modal) => {
      modal.classList.remove('modal--visible');
      modal.setAttribute('aria-hidden', 'true');
    });

    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.classList.add('modal--visible');
    trapFocus(this.modal, this.modal.querySelector('[aria-label="Close"]'));
    setTimeout(() => {
      this.freezeScroll && document.body.classList.add('overflow-hidden');
    }, 300);

    trackLinkClick(e);
  }

  hideModal(e) {
    this.freezeScroll && document.body.classList.remove('overflow-hidden');
    setTimeout(() => {
      this.modal.setAttribute('aria-hidden', 'true');
      this.modal.classList.remove('modal--visible');
      this.modal.classList.add('loading');
      removeTrapFocus(this.openedBy);
    }, 300);
  }

  loadModalContent() {
    // targets
    const modalImage = this.modal.querySelector('[data-modal-image] img'),
          modalTitles = this.modal.querySelectorAll('[data-modal-title]'),
          modalVariantTitles = this.modal.querySelectorAll('[data-modal-variant-title]'),
          modalDescription = this.modal.querySelector('[data-modal-description]'),
          modalDetails = this.modal.querySelector('[data-details]'),
          modalSwatchLink = this.modal.querySelector('[data-swatch-link]'),
          materialsOptionSelectListWrapper = this.modal.querySelector('[data-materials-option-select-list]')

    // handle load process
    let imageLoadTime = 0;
    let loadDelay = setInterval(() => {
      imageLoadTime += 100;
      if (imageLoadTime > 600) clearInterval(loadDelay);
    }, 100);

    function removeImageLoadingClass() {
      this.modal.classList.remove('loading-image');
      clearInterval(loadDelay);
    }
    modalImage.onload = () => {
      setTimeout(removeImageLoadingClass.bind(this), 600 - imageLoadTime);
    }

    // values
    const modalId = this.dataset.modalBlockId,
          materialGroupTitle = this.dataset.materialGroupTitle,
          landedProductID = JSON.parse(this.dataset.landedProductId),
          products = JSON.parse(this.dataset.products),
          productsImageUrls = this.dataset.productsImageUrls.split('|'),
          productsDescriptions = this.dataset.productsDescriptions.split('|'),
          productsDetails = this.dataset.productsDetails.split('|'),
          includeOrderSwatches = this.dataset.includeOrderSwatches !== 'false',
          showSwatchesCtas = this.dataset.showSwatchesCtas !== 'false',
          discludeSwatchOrderMessage = this.dataset.discludeSwatchOrderMessage !== 'false'

    let productsWithMetadata = products.map((product, index) => {
      // add imageUrls, Descriptions and Details 
      // to each product object
      product.imageUrl = productsImageUrls[index];
      product.romance_copy = productsDescriptions[index];
      product.product_details = JSON.parse(productsDetails[index]);

      return product;
    });

    // sort products to put the landed product first
    productsWithMetadata = productsWithMetadata.sort((a, b) => {
      if (a.id === landedProductID) {
        return -1;
      } else if (b.id === landedProductID) {
        return 1;
      }
      return 0;
    });
    
    this.modal.classList.add('loading');
    this.modal.classList.add('loading-image');

    materialsOptionSelectListWrapper.innerHTML = this.buildMaterialsOptionSelectListHTML(productsWithMetadata);

    modalImage.srcset = generateSrcset(productsWithMetadata[0].imageUrl, [550, 720, 990, 1100, 1500, 2200, 3000]);
    modalImage.src = productsWithMetadata[0].imageUrl;

    modalTitles.forEach((title) => {
      if (productsWithMetadata[0].title.indexOf(' - ') === -1) {
        title.innerHTML = productsWithMetadata[0].title;
      } else {
        title.innerHTML = productsWithMetadata[0].title.split(' - ')[1];
      }
      if (productsWithMetadata[0].title.split(' - ').length == 1) {
        title.closest('[data-modal-title-wrap]')?.classList.add('no-title');
      } else {
        title.closest('[data-modal-title-wrap]')?.classList.remove('no-title');
      }
    });
    modalVariantTitles.forEach((title) => {
      title.innerHTML = productsWithMetadata[0].title.split(' - ')[0];
    });
    modalDescription.innerHTML = productsWithMetadata[0].product_details?.romance_copy;
    modalDetails.innerHTML = '<hr class="materials-gallery__modal-detail-divider" />';
    for (let i=1; i<7; i++) {
      if (productsWithMetadata[0].product_details && productsWithMetadata[0].product_details[`drawer_header_${i}`] && productsWithMetadata[0].product_details[`drawer_content_${i}`]) {
        const detailHTML = `<h3 class="materials-gallery__modal-detail-title">${productsWithMetadata[0].product_details[`drawer_header_${i}`]}</h3>
                            <p class="materials-gallery__modal-detail-text">
                              ${productsWithMetadata[0].product_details[`drawer_content_${i}`].replace("\n", "<br>")}
                            </p>
                            <hr class="materials-gallery__modal-detail-divider" />`
        modalDetails.innerHTML += detailHTML;
      }
    }

    // <div data-swatch-link class="materials-gallery__modal-swatch-link">
    //   <a href="">Order Swatches</a>
    //   <span class="materials-gallery__modal-swatch-link-message">{{ disclude_swatch_order_message | default: 'Please contact design@maidenhome.com to inquire or acquire a swatch.' }}</span>
    // </div>
    if (showSwatchesCtas == false) {
      modalSwatchLink.classList.add('materials-gallery__modal-swatch-link--hide');
    }else if (includeOrderSwatches) {
      // /collections/materials-archive#{{ landed_product.title | split: ' - ' | last | downcase | replace: ' ', '-' }}
      const swatchLinkUrl = `/collections/materials-archive#${materialGroupTitle.toLowerCase().replace(/ /g, '-')}`;
      modalSwatchLink.querySelector('a').setAttribute('href', swatchLinkUrl);
      modalSwatchLink.classList.remove('materials-gallery__modal-swatch-link--disclude');
    } else {
      modalSwatchLink.classList.add('materials-gallery__modal-swatch-link--disclude');
    }

    // console.log('productsWithMetadata', productsWithMetadata);
    // console.log('details', productsWithMetadata[0].product_details['drawer_header_1']);
                
    this.modal.classList.add('loading');
    this.modal.dataset.modalId = modalId;

    setTimeout(() => {
      this.modal.classList.remove('loading');
    }, 500);
  }

  buildMaterialsOptionSelectListHTML(productsWithMetadata) {
    let materialOptionSelectListHTML = `<materials-option-select-list><ul data-showmore-list class="materials-gallery__modal-options">`;
    productsWithMetadata.forEach((product, index) => {
      const availableSizes = [550, 720, 990, 1100, 1500, 2200, 3000];

      const title_parts = product.title.split(' - '),
            image_url = product.imageUrl || product.images[0].src,
            image_srcset = generateSrcset(image_url, availableSizes),
            image_url_48 = image_url.replace(/width=\d+/, 'width=48'),
            image_url_200 = image_url.replace(/width=\d+/, 'width=200'),
            image_url_3000 = image_url.replace(/width=\d+/, 'width=3000'),
            romance_copy = product.romance_copy,
            product_details = product.product_details

      const swatchHTML = `<li class="materials-gallery__modal-option ${index === 0 ? 'selected' : ''}">
                            <button data-option class="materials-gallery__modal-option-button"
                              data-title="${title_parts[1]}" 
                              data-variant-title="${title_parts[0]}" 
                              data-description="${product_details?.romance_copy}" 
                              data-image_url="${image_url_3000}" 
                              data-product-id="${product.id}"
                              data-product-title="${product.title}"
                              data-product-url="${product.url}"
                              data-product-details='${JSON.stringify(product_details).replace("'", "&#39;")}'
                            >
                              <img src="${image_url_48}" img_url="${image_url_3000}" alt="${product.title}" />
                              <span class="sr-only">${product.title}</span>
                            </button>
                          </li>`

      materialOptionSelectListHTML += swatchHTML;
    });

    const itemsToShow = isMobile() ? 6 : 5,
          showMoreButtonHTML = `<button data-showmore-button aria-label="Show More" class="materials-gallery__modal-options__showmore" aria-expanded="false">
                                  <span class="materials-gallery__modal-options__showmore-more-text">+<span data-showmore-amount>${productsWithMetadata.length - itemsToShow}</span></span>
                                  <span class="materials-gallery__modal-options__showmore-less-text">Less</span>
                                </button>`
    materialOptionSelectListHTML += showMoreButtonHTML;

    materialOptionSelectListHTML += `</ul></materials-option-select-list>`;

    return materialOptionSelectListHTML;
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hideModal();
  }

  onFocusOut(e) {
    if (this.modal.contains(e.currentTarget)) return;
    // console.log(e.relatedTarget, e.target.closest('.materials-gallery__item'));

    setTimeout(() => {
      // console.log('on focus out')
      if (this.modal.getAttribute('aria-hidden') == 'false' && !this.modal.contains(document.activeElement))
        this.hideModal();
    });
  }

  _hideModalOnScroll() {
    this._hideModal();
  }
}

customElements.define('materials-gallery-modal-trigger', MaterialsGalleryModalTrigger);